// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    deleteOption,
    getOptionCodes
} from '../../shared/repositories';
import actions from '../../actions-list';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateOptionCodes = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getOptionCodes(pin);

            dispatch({
                payload,
                property: 'optionCodes',
                type: actions.UPDATE_OPTION_CODES_SUCCESS
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const deleteProductOption = (pin, id) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await deleteOption(pin, id);

            successAlertBar(translate('OPTION_CODE_DELETED_SUCCESSFULLY'));

            updateOptionCodes(pin)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/option-codes.js